import { useState, useEffect, useCallback, useMemo } from "react";
import { useProjectApi } from "../../../hooks/useProjectApi";
import { useResourceApi } from "../../../hooks/useResourceApi";

export const useAllProjectMilestoneHistoryViewModel = (projectId) => {
  console.log("projectId", projectId);

  const [milestoneHistory, setMilestoneHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getProjectMilestoneHistory } = useProjectApi();

  const {
    getResources,
    cacheOperations: { readResources, writeResources },
  } = useResourceApi();

  const fetchProjectMilestoneHistory = useCallback(async () => {
    if (!loading) setLoading(true);
    try {
      const [result, resourceResult] = await Promise.all([
        getProjectMilestoneHistory(projectId),
        getResources(),
      ]);

      if (!result.success || !resourceResult.success) {
        throw new Error("Failed to fetch required data");
      }
      setMilestoneHistory(result.data);

      if (resourceResult.data?.GetResources) {
        writeResources(resourceResult.data.GetResources);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [projectId, getProjectMilestoneHistory, getResources, writeResources]);

  useEffect(() => {
    fetchProjectMilestoneHistory();
  }, []);

  return {
    milestoneHistory,
    loading: loading,
    error,
    refetch: fetchProjectMilestoneHistory,
  };
};
